import React from 'react';
import Box from '@mui/material/Box';

export default function ColumnBox(props) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap',
            ...(props.sx || {}) }} onClick={props.onClick}>
            { props.children }
        </Box>
    )
}
